export enum ResponseTime {
    Short = 1,
    Medium,
    Long,
}
